import { render, staticRenderFns } from "./IncomeReceipt.vue?vue&type=template&id=45eaba59&scoped=true"
import script from "./IncomeReceipt.vue?vue&type=script&lang=js"
export * from "./IncomeReceipt.vue?vue&type=script&lang=js"
import style0 from "./IncomeReceipt.vue?vue&type=style&index=0&id=45eaba59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eaba59",
  null
  
)

export default component.exports